import { InjectionToken } from '@angular/core';

/**
 * Configuration for the Feature Flags API
 */
export interface FeatureApiConfig {
  /**
   * Base URL for the feature flags API
   */
  apiBaseUrl: string;
}

/**
 * Injection token for the Feature Flags API configuration
 */
export const FEATURE_API_CONFIG = new InjectionToken<FeatureApiConfig>('feature api configuration');
